import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { MachidukuriSummary } from './MachidukuriSummary'
import { MachidukuriThoughts } from './MachidukuriThoughts'
import { BlogItem } from '@/components/elements/Blog/BlogItem'

export const Detailed = () => {
  return (
    <div>
      <TopMessageContainer>
        <TopMessageText>
          <BlockTitle>街づくりプロジェクト</BlockTitle>
          <p>
          株式会社トライアルホールディングスは、子会社の株式会社トライアルリアルエステートを代表企業として、国立大学法人九州大学および独立行政法人都市再生機構（UR都市機構）が公募主体となり、両者が福岡県福岡市に所有する28ヘクタールの土地の開発案件への応募を行っていましたが、残念ながら優先交渉権を獲得することはできませんでした。
          </p>
          <p>
          しかし、当社が提案をした<strong>「ALL JAPANでDXを推進する」</strong>、<strong>「博多ベイエリアを日本のシリコンバレーにする」</strong>というビジョンが変わることはありません。
          </p>
          <p>
          トライアルは本案件でご提案させていただいた内容を実現するために、今後もあらゆる可能性を探ります。
          </p>
        </TopMessageText>
      </TopMessageContainer>
      <BlockTitle>プロジェクト概要</BlockTitle>
      <SummaryContainer>
        {MachidukuriSummary.map((summary, index) => (
          <div key={index}>
            <SummaryTitle>{summary.title}</SummaryTitle>
            {summary.images.map((image, idx) => (
              <Image key={idx} src={image} />
            ))}
            {index === 2 && (
              <LinkContainer>
                宮若市での取り組みについてはこちら：
                <Link href="https://trial-holdings.inc/business">
                  <a target="_blank" rel="noopener noreferrer">
                    https://trial-holdings.inc/business/
                  </a>
                </Link>
              </LinkContainer>
            )}
          </div>
        ))}
      </SummaryContainer>
      <BlockTitle>プロジェクトの思い</BlockTitle>
      <List>
        {MachidukuriThoughts.map((item) => (
          <BlogItem
            isPickUp={false}
            pickUpSummary={null}
            utilMeta={null}
            individualMeta={null}
            {...item}
            key={item._id}
          />
        ))}
      </List>
    </div>
  )
}

const List = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 47px 46px;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    justify-content: normal;
    row-gap: 24px;
    padding: 0 20px;
  }
`

const TopMessageContainer = styled.div`
  width: 1040px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
  }
`

const TopMessageText = styled.div`
  width: 100%;
  font-size: 18px;
  color: ${theme.colors.textTitle};
  text-align: left;
  letter-spacing: 0.36px;
  line-height: 32px;

  strong{
    font-weight: bold;
  }

  h3 {
    font-size: 28px;
    letter-spacing: 1.68px;
    font-weight: bold;
    color: ${theme.colors.trialBlue};
    margin-bottom: 44px;
  }

  p {
    margin-bottom: 2em;
  }

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    letter-spacing: 0.6px;
    line-height: 25px;
    margin-top: 58px;
    margin-bottom: 0px;

    h3 {
      max-width: 225px;
      font-size: 20px;
      letter-spacing: 2px;
      line-height: 30px;
      margin-bottom: 30px;
    }
  }
`

const BlockTitle = styled.h4`
  margin-top: 80px;
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 1.68px;
  line-height: 42px;
  color: ${theme.colors.trialBlue};

  @media screen and (max-width: 1047px) {
    margin-top: 30px;
    font-size: 20px;
    letter-spacing: 1.2px;
    line-height: 28px;
  }

  &:first-child {
    margin-top: 0;
  }
`

const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`

const SummaryTitle = styled.h5`
  margin-bottom: 10px;
  font-size: 18px;
  letter-spacing: 1.68px;
  line-height: 42px;
  @media screen and (max-width: 1047px) {
    font-size: 16px;
    letter-spacing: 1.2px;
    line-height: 28px;
  }
`

const LinkContainer = styled.div`
  font-weight: bold;
  margin-top: 20px;
  line-height: 1.8;
  
  & > a:hover {
    text-decoration: underline;
  }
`

const Image = styled.img`
  width: 100%;
  margin-bottom: 10px;
`
